<template>
  <div>
    <div class="center-button-invoice mb-0 mt-3">
      <button class="btn btn-danger btn-block" @click="rdr_back" type="button">
        Back
      </button>
      <button
        class="btn btn-info btn-block"
        @click="generateReport"
        type="button"
      >
        Download
      </button>
    </div>

    <vue-html2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      :filename="filename"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <table
          cellpadding="0"
          cellspacing="0"
          width="100%"
          align="center"
          border="0"
        >
          <tbody>
            <tr>
              <td align="center" valign="top">
                <table
                  class="em_main_table"
                  style="table-layout: fixed"
                  cellpadding="0"
                  cellspacing="0"
                  width="800"
                  align="center"
                  border="0"
                >
                  <tbody>
                    <tr>
                      <td
                        class="em_side"
                        width="20"
                        style="font-size: 1px; line-height: 1px"
                      >
                        &nbsp;
                      </td>
                      <td align="left" valign="top"></td>
                      <td
                        class="em_side"
                        width="20"
                        style="font-size: 1px; line-height: 1px"
                      >
                        &nbsp;
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td align="center" bgcolor="#F7F7F7" valign="top">
                <table
                  class="em_main_table"
                  style="table-layout: fixed"
                  cellpadding="0"
                  cellspacing="0"
                  width="800"
                  align="center"
                  border="0"
                >
                  <tbody>
                    <tr>
                      <td
                        class="em_side"
                        width="20"
                        style="font-size: 1px; line-height: 1px"
                      >
                        &nbsp;
                      </td>
                      <td align="left" valign="top">
                        <table
                          cellpadding="0"
                          cellspacing="0"
                          width="100%"
                          align="left"
                          bgcolor="#F7F7F7"
                          border="0"
                        >
                          <tbody>
                            <tr>
                              <td
                                style="font-size: 1px; line-height: 1px"
                                class=""
                                height="70"
                              >
                                &nbsp;
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <table
                                  cellpadding="0"
                                  cellspacing="0"
                                  width="100%"
                                  align="left"
                                  border="0"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        style="
                                          font-family: GT Walsheim Bold, Poppins,
                                            Helvetica, Arial, sans-serif;
                                          font-weight: bold;
                                          font-style: normal;
                                          text-align: left;
                                        "
                                        align="left"
                                        valign="middle"
                                      >
                                        <span style="font-size: 20px"
                                          >Invoice </span
                                        ><span style="font-size: 16px"
                                          >#{{ data.srv_t_code }}</span
                                        >
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        colspan="2"
                                        style="
                                          height: 20px;
                                          border-bottom: 1px solid
                                            rgb(226, 226, 226);
                                          font-size: 1px;
                                          line-height: 1px;
                                        "
                                        height="20"
                                      >
                                        &nbsp;
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="font-size: 1px; line-height: 1px"
                                        class=""
                                        height="50"
                                      >
                                        &nbsp;
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="text-align: left"
                                        align="left"
                                        valign="middle"
                                      >
                                        <section class="image-container">
                                          <img
                                            width="155"
                                            height="36"
                                            class="user-image"
                                            src="https://mayindri.online/titip/chevicar/assets/img/logo_chevicar%20oto.png"
                                            alt="User Image"
                                            ref="userImage"
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              font-style: normal;
                                              text-align: center;
                                              font-size: 12px;
                                              /* width: 155px; */
                                              height: 61px;
                                              border: 0 solid;
                                              display: block;
                                            "
                                          />
                                        </section>
                                      </td>
                                      <td
                                        style="
                                          font-family: GT Walsheim Bold, Poppins,
                                            Helvetica, Arial, sans-serif;
                                        "
                                        align="right"
                                        valign="middle"
                                      >
                                        <div
                                          style="
                                            font-style: normal;
                                            font-size: 12px;
                                            text-align: right;
                                          "
                                        >
                                          {{ data.srv_t_date }}
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="font-size: 1px; line-height: 1px"
                                class="em_height"
                                height="50"
                              >
                                &nbsp;
                              </td>
                            </tr>
                            <!-- <tr>
                              <td
                                height="30"
                                style="
                                  font-family: GT Walsheim, Poppins, Helvetica,
                                    Arial, sans-serif;
                                  font-weight: bold;
                                  font-style: normal;
                                  text-align: left;
                                  font-size: 11px;
                                  line-height: 30px;
                                "
                                align="left"
                                valign="top"
                              >
                                Billed to
                              </td>
                            </tr> -->
                            <!-- <tr>
                              <td
                                height="30"
                                style="
                                  font-family: GT Walsheim, Poppins, Helvetica,
                                    Arial, sans-serif;
                                  color: rgb(122, 122, 122);
                                  font-style: normal;
                                  text-align: left;
                                  font-size: 12px;
                                  line-height: 20px;
                                "
                                align="left"
                                valign="top"
                              >
                                <span>{{ data.usr_fullname }}<br /></span
                                ><span>{{ data.usr_phone }}<br /></span
                                ><span>{{ data.usr_address }}<br /><br /></span>
                              </td>
                            </tr> -->
                            <tr>
                              <table
                                cellpadding="0"
                                cellspacing="0"
                                width="100%"
                                align="left"
                                border="0"
                              >
                                <tbody>
                                  <tr>
                                    <td
                                      height="30"
                                      style="
                                        font-family: GT Walsheim, Poppins,
                                          Helvetica, Arial, sans-serif;
                                        font-weight: bold;
                                        font-style: normal;
                                        text-align: left;
                                        font-size: 11px;
                                        line-height: 30px;
                                      "
                                      align="left"
                                      valign="top"
                                    >
                                      Billed to
                                    </td>
                                    <td
                                      style="
                                        font-family: GT Walsheim, Poppins,
                                          Helvetica, Arial, sans-serif;
                                        font-weight: bold;
                                        font-style: normal;
                                        text-align: right;
                                        font-size: 11px;
                                        line-height: 30px;
                                      "
                                      align="right"
                                      valign="middle"
                                    >
                                      <div
                                        style="
                                          font-style: normal;
                                          font-size: 12px;
                                          text-align: right;
                                        "
                                      >
                                        
                                      </div>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td
                                      height="30"
                                      style="
                                        font-family: GT Walsheim, Poppins,
                                          Helvetica, Arial, sans-serif;
                                        color: rgb(122, 122, 122);
                                        font-style: normal;
                                        text-align: left;
                                        font-size: 12px;
                                        line-height: 20px;
                                      "
                                      align="left"
                                      valign="top"
                                    >
                                      <span>{{ data.usr_fullname }}<br /></span
                                      ><span>{{ data.usr_phone }}<br /></span
                                      ><span
                                        >{{ data.usr_address }}<br /><br
                                      /></span>
                                    </td>
                                    <td
                                      height="30"
                                      style="
                                        font-family: GT Walsheim, Poppins,
                                          Helvetica, Arial, sans-serif;
                                        color: rgb(122, 122, 122);
                                        font-style: normal;
                                        text-align: right;
                                        font-size: 12px;
                                        line-height: 20px;
                                      "
                                      align="right"
                                      valign="top"
                                    >
                                      <span>{{ data.crs_brand_name }}<br /></span>
                                      <span>{{ data.crs_model_name }}<br /></span>
                                      <span>{{ data.cst_crs_police_number }}<br/></span>
                                      <span>KM {{ numberWithCommas(data.srv_t_km) }}<br /></span>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </tr>
                            <tr>
                              <td
                                style="font-size: 1px; line-height: 1px"
                                class="eml_height"
                                height="70"
                              >
                                &nbsp;
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <div>
                                  <table
                                    cellpadding="0"
                                    cellspacing="0"
                                    width="100%"
                                    align="left"
                                    border="0"
                                  >
                                    <tbody>
                                      <tr>
                                        <td
                                          colspan="2"
                                          style="
                                            font-family: GT Walsheim Bold,
                                              Poppins, Helvetica, Arial,
                                              sans-serif;
                                            font-size: 11px;
                                            text-align: left;
                                            text-transform: uppercase;
                                            padding-top: 15px;
                                            padding-bottom: 15px;
                                            border-bottom: 1px solid
                                              rgb(230, 230, 230);
                                          "
                                          align="left"
                                          valign="middle"
                                        >
                                          Items
                                        </td>
                                        <td
                                          style="
                                            font-family: GT Walsheim Bold,
                                              Poppins, Helvetica, Arial,
                                              sans-serif;
                                            font-size: 11px;
                                            text-align: left;
                                            text-transform: uppercase;
                                            padding-top: 15px;
                                            padding-bottom: 15px;
                                            border-bottom: 1px solid
                                              rgb(230, 230, 230);
                                          "
                                          align="left"
                                          valign="middle"
                                        >
                                          Desc
                                        </td>
                                        <td
                                          style="
                                            font-family: GT Walsheim Bold,
                                              Poppins, Helvetica, Arial,
                                              sans-serif;
                                            font-size: 11px;
                                            text-align: right;
                                            text-transform: uppercase;
                                            padding-top: 15px;
                                            padding-bottom: 15px;
                                            border-bottom: 1px solid
                                              rgb(230, 230, 230);
                                          "
                                          align="right"
                                          valign="middle"
                                        >
                                          Harga Satuan
                                        </td>
                                        <td
                                          style="
                                            font-family: GT Walsheim Bold,
                                              Poppins, Helvetica, Arial,
                                              sans-serif;
                                            font-size: 11px;
                                            text-align: right;
                                            text-transform: uppercase;
                                            padding-left: 5px;
                                            padding-top: 15px;
                                            padding-bottom: 15px;
                                            border-bottom: 1px solid
                                              rgb(230, 230, 230);
                                            width: 85px;
                                          "
                                          align="right"
                                          valign="middle"
                                        >
                                          Qty
                                        </td>
                                        <td
                                          style="
                                            font-family: GT Walsheim Bold,
                                              Poppins, Helvetica, Arial,
                                              sans-serif;
                                            font-size: 11px;
                                            text-align: right;
                                            text-transform: uppercase;
                                            padding-left: 5px;
                                            padding-top: 15px;
                                            padding-bottom: 15px;
                                            border-bottom: 1px solid
                                              rgb(230, 230, 230);
                                            width: 85px;
                                          "
                                          align="right"
                                          valign="middle"
                                        >
                                          Disc (%)
                                        </td>
                                        <td
                                          style="
                                            font-family: GT Walsheim Bold,
                                              Poppins, Helvetica, Arial,
                                              sans-serif;
                                            font-size: 11px;
                                            text-align: right;
                                            text-transform: uppercase;
                                            padding-left: 5px;
                                            padding-top: 15px;
                                            padding-bottom: 15px;
                                            border-bottom: 1px solid
                                              rgb(230, 230, 230);
                                            width: 85px;
                                          "
                                          align="right"
                                          valign="middle"
                                        >
                                          Price (IDR)
                                        </td>
                                      </tr>

                                      <template v-if="bind_services.length > 0">
                                        <tr style="background: #cacaca">
                                          <td
                                            class="play"
                                            height="48"
                                            style="
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                              mso-line-height-rule: exactly;
                                              line-height: 25px;
                                              padding-left: 20px;
                                            "
                                            align="left"
                                            valign="middle"
                                            colspan="7"
                                          >
                                            Servis
                                          </td>
                                        </tr>

                                        <tr
                                          v-for="(item, index) in bind_services"
                                          :key="index + 'bind_services'"
                                        >
                                          <td
                                            class="play"
                                            width="23"
                                            height="48"
                                            style="
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                              mso-line-height-rule: exactly;
                                              line-height: 25px;
                                            "
                                            align="left"
                                            valign="middle"
                                          ></td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              font-size: 12px;
                                              text-align: left;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="left"
                                            valign="middle"
                                          >
                                            {{ item.srv_name }}
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              max-width: 88px;
                                              margin-right: 10px !important;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            <span>-<br /></span>
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            {{ $root.numberWithCommas(item.srv_act_price) }}
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            -
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              max-width: 88px;
                                              margin-right: 10px !important;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            {{ item.srv_discount }} %
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            Rp {{
                                              $root.numberWithCommas(
                                                item.srv_total_price
                                              )
                                            }}
                                          </td>
                                        </tr>
                                      </template>

                                      <template
                                        v-if="bind_services_bulk.length > 0"
                                      >
                                        <tr style="background: #cacaca">
                                          <td
                                            class="play"
                                            height="48"
                                            style="
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                              mso-line-height-rule: exactly;
                                              line-height: 25px;
                                              padding-left: 20px;
                                            "
                                            align="left"
                                            valign="middle"
                                            colspan="7"
                                          >
                                            Paket Servis
                                          </td>
                                        </tr>
                                        <tr
                                          v-for="(
                                            item, index
                                          ) in bind_services_bulk"
                                          :key="index + 'bind_services_bulk'"
                                        >
                                          <td
                                            class="play"
                                            width="23"
                                            height="48"
                                            style="
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                              mso-line-height-rule: exactly;
                                              line-height: 25px;
                                            "
                                            align="left"
                                            valign="middle"
                                          ></td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              font-size: 12px;
                                              text-align: left;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="left"
                                            valign="middle"
                                          >
                                            {{ item.srv_b_name }}
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              max-width: 88px;
                                              margin-right: 10px !important;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            <div
                                              v-html="item.srv_b_description"
                                            ></div>
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              max-width: 88px;
                                              margin-right: 10px !important;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            -
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              max-width: 88px;
                                              margin-right: 10px !important;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            -
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            -
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            Rp {{
                                              $root.numberWithCommas(
                                                item.srv_b_act_price
                                              )
                                            }}
                                          </td>
                                        </tr>
                                      </template>

                                      <template v-if="bind_prd.length > 0">
                                        <tr style="background: #cacaca">
                                          <td
                                            class="play"
                                            height="48"
                                            style="
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                              mso-line-height-rule: exactly;
                                              line-height: 25px;
                                              padding-left: 20px;
                                            "
                                            align="left"
                                            valign="middle"
                                            colspan="7"
                                          >
                                            Produk
                                          </td>
                                        </tr>
                                        <tr
                                          v-for="(item, index) in bind_prd"
                                          :key="index + 'bind_prd'"
                                        >
                                          <td
                                            class="play"
                                            width="23"
                                            height="48"
                                            style="
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                              mso-line-height-rule: exactly;
                                              line-height: 25px;
                                            "
                                            align="left"
                                            valign="middle"
                                          ></td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              font-size: 12px;
                                              text-align: left;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="left"
                                            valign="middle"
                                          >
                                            {{ item.prd_name }}
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim, Poppins,
                                                Helvetica, Arial, sans-serif;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              max-width: 88px;
                                              margin-right: 10px !important;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            <span>-<br /></span>
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            Rp {{
                                              $root.numberWithCommas(
                                                item.prd_purchase
                                              )
                                            }}
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            {{ item.prd_qty }}
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            -
                                          </td>
                                          <td
                                            style="
                                              font-family: GT Walsheim Bold,
                                                Poppins, Helvetica, Arial,
                                                sans-serif;
                                              width: 85px;
                                              text-align: right;
                                              font-size: 12px;
                                              color: rgb(122, 122, 122);
                                              padding-top: 13px;
                                              padding-bottom: 17px;
                                              border-bottom: 1px solid
                                                rgb(230, 230, 230);
                                            "
                                            align="right"
                                            valign="middle"
                                          >
                                            Rp {{
                                              $root.numberWithCommas(
                                                item.prd_total_price
                                              )
                                            }}
                                          </td>
                                        </tr>
                                      </template>
                                    </tbody>
                                  </table>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="font-size: 1px; line-height: -3px"
                                class=""
                                height="20"
                              >
                                &nbsp;
                              </td>
                            </tr>
                            <tr>
                              <td>
                                <table
                                  cellpadding="0"
                                  cellspacing="0"
                                  width="280px"
                                  align="right"
                                  border="0"
                                >
                                  <tbody>
                                    <tr>
                                      <td
                                        style="
                                          font-family: GT Walsheim Bold, Poppins,
                                            Helvetica, Arial, sans-serif;
                                          width: 180px;
                                          font-weight: bold;
                                          font-style: normal;
                                          font-size: 12px;
                                          text-align: right;
                                          padding-right: 30px;
                                          padding-top: 15px;
                                          padding-bottom: 5px;
                                        "
                                        align="right"
                                        valign="middle"
                                      >
                                        Sub Total
                                      </td>
                                      <td
                                        style="
                                          font-family: GT Walsheim Bold, Poppins,
                                            Helvetica, Arial, sans-serif;
                                          width: 180px;
                                          font-weight: bold;
                                          font-style: normal;
                                          font-size: 16px;
                                          text-align: right;
                                          padding-left: 5px;
                                          padding-top: 15px;
                                          padding-bottom: 5px;
                                        "
                                        align="right"
                                        valign="middle"
                                      >
                                        Rp {{
                                          $root.numberWithCommas(
                                            data.srv_t_actual_price
                                          )
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="
                                          font-family: GT Walsheim Bold, Poppins,
                                            Helvetica, Arial, sans-serif;
                                          width: 180px;
                                          font-weight: bold;
                                          font-style: normal;
                                          font-size: 12px;
                                          text-align: right;
                                          padding-right: 30px;
                                          padding-top: 15px;
                                          padding-bottom: 5px;
                                        "
                                        align="right"
                                        valign="middle"
                                      >
                                        Booking Fee
                                      </td>
                                      <td
                                        style="
                                          font-family: GT Walsheim Bold, Poppins,
                                            Helvetica, Arial, sans-serif;
                                          width: 180px;
                                          font-weight: bold;
                                          font-style: normal;
                                          font-size: 16px;
                                          text-align: right;
                                          padding-left: 5px;
                                          padding-top: 15px;
                                          padding-bottom: 5px;
                                        "
                                        align="right"
                                        valign="middle"
                                      >
                                        Rp {{
                                          $root.numberWithCommas(data.srv_t_dp)
                                        }}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        style="
                                          font-family: GT Walsheim Bold, Poppins,
                                            Helvetica, Arial, sans-serif;
                                          font-weight: bold;
                                          font-style: normal;
                                          font-size: 12px;
                                          padding-right: 30px;
                                          text-align: right;
                                          padding-top: 15px;
                                          padding-bottom: 5px;
                                        "
                                        align="right"
                                        valign="middle"
                                      >
                                        Total Pembayaran
                                      </td>
                                      <td
                                        style="
                                          font-family: GT Walsheim Bold, Poppins,
                                            Helvetica, Arial, sans-serif;
                                          width: 180px;
                                          font-weight: bold;
                                          font-style: normal;
                                          font-size: 16px;
                                          text-align: right;
                                          padding-left: 5px;
                                          padding-top: 15px;
                                          padding-bottom: 5px;
                                        "
                                        align="right"
                                        valign="middle"
                                      >
                                        Rp {{                                          
                                          $root.numberWithCommas(getSisaPembayaran)
                                        }}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                            <tr>
                              <td
                                style="font-size: 13px; line-height: 1px; font-style: italic"
                                class=""
                                height="70"
                                align="right"
                              >
                                *Pembayaran bisa transfer ke no. rekening BCA : 210.11.76.438 a.n Rasim Rusdianto
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </td>
                      <td
                        class="em_side"
                        width="20"
                        style="font-size: 1px; line-height: 1px"
                      >
                        &nbsp;
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </section>
    </vue-html2pdf>
  </div>
</template>

<script>
export default {
  data() {
    return {
      module: "Transaksi Servis",
      table_module: "services_transaction",
      alias_table: "srv_t",
      data: {},
      error: {},
      uuid: this.$route.params.uuid,
      detailBulk: [],
      detailService: [],
      detailProducts: [],
    };
  },
  computed: {
    bind_services() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Service";
        });

        for (const key in result) {
          result[key]["spr"] = null;
          if (result[key]["spr_id"] != 0 && result[key]["spr_id"] != null) {
            result[key]["spr"] = {
              spr_id: result[key]["spr_id"],
              spr_name: result[key]["spr_name"],
            };
          }
        }
      }
      return result;
    },
    bind_services_bulk() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Service Bulk";
        });
      }
      return result;
    },
    bind_prd() {
      var result = [];
      if (typeof this.data.srv_t_r !== "undefined") {
        result = this.data.srv_t_r.filter(function (srv) {
          return srv.srv_t_d_type_name == "Products";
        });
      }
      return result;
    },
    filename() {
      var date = this.data.srv_t_code;
      return date;
    },
    getSisaPembayaran(){
      let result = 0
      if (typeof this.data.srv_t_actual_price !== 'undefined' && this.data.srv_t_actual_price !== null && this.data.srv_t_actual_price !== '') 
      {
        result = this.data.srv_t_actual_price - this.data.srv_t_dp;        
      }

      return result;

    }
  },
  mounted() {
    this.axios
      .get(this.table_module + "/detail/" + this.uuid)
      .then((response) => {
        this.data = response.data.data;
      });
  },
  methods: {
    numberWithCommas(arm) {
      if (arm != "" && arm != null) {
        return arm.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return 0;
    },
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    rdr_back() {
      this.$router.push({ name: this.table_module });
    },    
  },
};
</script>

<style>
.center-button-invoice {
  margin: 0;
  width: 550px;
  position: absolute;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

@font-face {
  font-family: "Poppins", sans-serif;
  font-weight: normal;
  font-style: normal;
}

a[x-apple-data-detectors] {
  color: inherit !important;
  text-decoration: none !important;
  font-size: inherit !important;
  font-family: inherit !important;
  font-weight: inherit !important;
  line-height: inherit !important;
}

body {
  -webkit-text-size-adjust: 100% !important;
  -ms-text-size-adjust: 100% !important;
  -webkit-font-smoothing: antialiased !important;
}

img {
  border: 0 !important;
  outline: none !important;
}

p {
  margin: 0 !important;
  padding: 0 !important;
}

table {
  border-collapse: collapse;
  mso-table-lspace: 0;
  mso-table-rspace: 0;
}

td,
a,
span {
  border-collapse: collapse;
  mso-line-height-rule: exactly;
}

.ExternalClass * {
  line-height: 100%;
}

span.MsoHyperlink {
  mso-style-priority: 99;
  color: inherit;
}

span.MsoHyperlinkFollowed {
  mso-style-priority: 99;
  color: inherit;
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  table[class="em_main_table"] {
    width: 100% !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  table[class="em_wrapper"] {
    width: 100% !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  td[class="em_center"] {
    text-align: center !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  td[class="em_height"] {
    height: 20px !important;
  }
  td[class="eml_height"] {
    height: 40px !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  td[class="em_hide"],
  br[class="em_hide"] {
    display: none !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  td[class="em_pad"] {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  td[class="em_top_pad"] {
    padding-top: 20px !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  img[class="em_img"] {
    width: 100% !important;
    height: auto !important;
  }
  img[class="logo_em_img"] {
    width: 180px !important;
    height: auto !important;
  }
}

@media only screen and (min-width: 481px) and (max-width: 599px) {
  td[class="em_side"] {
    width: 10px !important;
  }
}

@media only screen and (max-width: 600px) {
  table[class="button_left"] {
    width: 100% !important;
  }
  td[class="play"] {
    line-height: 48px !important;
  }
}

@media only screen and (max-width: 580px) {
  .firstbtn {
    width: 100% !important;
    margin-right: 0 !important;
  }
  .secondbtn {
    width: 100% !important;
  }
}

@media only screen and (max-width: 480px) {
  table[class="em_wrapper"] {
    width: 100% !important;
  }
}

@media only screen and (max-width: 480px) {
  td[class="em_center"] {
    text-align: center !important;
  }
}

@media only screen and (max-width: 480px) {
  td[class="em_height"] {
    height: 20px !important;
  }
  td[class="eml_height"] {
    height: 40px !important;
  }
}

@media only screen and (max-width: 480px) {
  td[class="em_hide"],
  br[class="em_hide"] {
    display: none !important;
  }
}

@media only screen and (max-width: 480px) {
  td[class="em_pad"] {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}

@media only screen and (max-width: 480px) {
  td[class="em_top_pad"] {
    padding-top: 20px !important;
  }
}

@media only screen and (max-width: 480px) {
  img[class="em_img"] {
    width: 100% !important;
    height: auto !important;
  }

  img[class="logo_em_img"] {
    width: 180px !important;
    height: auto !important;
  }
}

@media only screen and (max-width: 480px) {
  td[class="em_side"] {
    width: 10px !important;
  }
}

@media only screen and (max-width: 480px) {
  td[class="em_font35"] {
    font-size: 35px !important;
    line-height: 38px !important;
  }
}

@media only screen and (max-width: 480px) {
  td[class="em_font30"] {
    font-size: 30px !important;
    line-height: 35px !important;
  }
}
</style>